<sb-dialog-content class="h-full">
  @if (!hasContractTemplates()) {
    <sb-notice>
      <h2 sbNoticeHeader>{{ "You don't have a contract template yet." | translate }}</h2>
      <p>
        {{
          "You'll need one to generate a contract, but no problem — continue your setup and we'll guide you through adding it in the next step."
            | translate
        }}
      </p>
    </sb-notice>
  }
  <form sb-dialog-form [formGroup]="form()" (ngSubmit)="submitted.emit()">
    <fieldset>
      <sb-form-field
        [required]="true"
        [errorWhen]="['touched']"
        [control]="form().controls['first_name']"
        [label]="'First name' | translate"
      >
        <input sbInput formControlName="first_name" />
      </sb-form-field>
      <sb-form-field
        [errorWhen]="['touched']"
        [control]="form().controls['prefix_name']"
        [label]="'Prefix' | translate"
        class="basis-1/3"
      >
        <input sbInput formControlName="prefix_name" />
      </sb-form-field>
      <sb-form-field
        [required]="true"
        [errorWhen]="['touched']"
        [control]="form().controls['last_name']"
        [label]="'Last name' | translate"
      >
        <input sbInput formControlName="last_name" />
      </sb-form-field>
    </fieldset>
    <fieldset>
      <sb-form-field
        [required]="true"
        [errorWhen]="['touched']"
        [control]="form().controls['email']"
        [label]="'Email' | translate"
      >
        <input sbInput formControlName="email" />
      </sb-form-field>
      <sb-form-field
        [control]="form().controls['phone']"
        [errorWhen]="['touched']"
        [label]="'Phone number' | translate"
      >
        <sb-phone-input formControlName="phone" [fallbackRegionCode]="phoneFallbackRegionCode()"></sb-phone-input>
      </sb-form-field>
    </fieldset>
    <fieldset>
      <sb-form-field
        [required]="true"
        [errorWhen]="['touched']"
        [control]="form().controls['job_title']"
        [label]="'Job title' | translate"
      >
        <input sbInput formControlName="job_title" />
      </sb-form-field>
      <sb-form-field
        [required]="true"
        [errorWhen]="['touched']"
        [control]="form().controls['start_date']"
        [label]="'Start date' | translate"
      >
        <sb-date-input [minDate]="today" [fullWidth]="true" formControlName="start_date" />
      </sb-form-field>
    </fieldset>
    <fieldset>
      @if (germanReleaseEnabled) {
        <sb-form-field
          [required]="true"
          [errorWhen]="['touched']"
          [control]="form().controls['country']"
          [label]="'Employment country' | translate"
          [tooltip]="'Sets which contract details we collect, based on local requirements.' | translate"
        >
          <sb-select [items]="countryItems" formControlName="country"></sb-select>
        </sb-form-field>
      }
      <sb-form-field
        [required]="true"
        [errorWhen]="['touched']"
        [control]="form().controls['locale']"
        [label]="'New hire language' | translate"
        [tooltip]="'Select the language in which the new hire will receive communications and documents.' | translate"
      >
        <sb-select [items]="languageItems()" formControlName="locale"> </sb-select>
      </sb-form-field>
      <sb-form-field
        [required]="true"
        [errorWhen]="['touched']"
        [control]="form().controls['team_id']"
        [label]="'Team' | translate"
        [tooltip]="'Select the team for the new hire.' | translate"
      >
        <sb-select [items]="teams()" [displayTree]="true" [searchable]="true" formControlName="team_id"> </sb-select>
      </sb-form-field>
    </fieldset>
    @if (showGermanFields()) {
      <fieldset>
        <sb-form-field
          [required]="true"
          [errorWhen]="['touched']"
          [control]="form().controls['employment_category']"
          [label]="'Employment category' | translate"
        >
          <sb-select [items]="employmentCategoryItems()" formControlName="employment_category"></sb-select>
        </sb-form-field>
        <sb-form-field
          [required]="true"
          [errorWhen]="['touched']"
          [control]="form().controls['food_handling']"
          [label]="'Is this a food-handling role?' | translate"
        >
          <sb-select [items]="foodHandlingItems" formControlName="food_handling"></sb-select>
        </sb-form-field>
      </fieldset>
    }
    @if (showPayrollNotice()) {
      <sb-notice [variant]="'info'">
        {{ 'This new hire will be added to payroll automatically once their contract is signed.' | translate }}
      </sb-notice>
    }
    @if (showGuardianSignature()) {
      <fieldset>
        <sb-checkbox formControlName="requires_guardian_signature" [truncateLabel]="false">
          {{ 'Requires guardian signature' | translate }}
        </sb-checkbox>
      </fieldset>

      @if (form().controls['requires_guardian_signature']?.value && showGuardianCount()) {
        <fieldset>
          <sb-form-field
            [control]="form().controls['guardian_signature_count']"
            [errorWhen]="['touched']"
            [label]="'Number of guardians' | translate"
            [tooltip]="
              'Choose how many legal guardians must co-sign the contract (e.g. for minor employees).' | translate
            "
          >
            <sb-select [items]="guardianSignatureCountItems" formControlName="guardian_signature_count"></sb-select>
          </sb-form-field>
        </fieldset>
      }
    }
  </form>
</sb-dialog-content>
